import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  Edit2, 
  Trash2, 
  CheckCircle, 
  X, 
  ArrowRight, 
  Square, 
  Zap,
  Layers
} from 'lucide-react';
import { cn } from '@/lib/utils';

const NodeContextMenu = ({ 
  nodeId,
  isInitial,
  isFinal,
  isCompound,
  position,
  onEdit,
  onDelete,
  onMarkInitial,
  onMarkFinal,
  onAddTransition,
  onAddEffect,
  onMakeCompound,
  onClose
}) => {
  return (
    <>
      <div 
        className="fixed inset-0 z-40"
        onClick={onClose}
      />
      <div
        className="fixed bg-[#1a1f3a] border border-white/20 rounded-lg shadow-2xl z-50 py-1 min-w-[180px]"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
        }}
        data-testid="node-context-menu"
      >
        {/* Edit State */}
        <button
          onClick={() => {
            onEdit();
            onClose();
          }}
          className="w-full px-3 py-2 text-sm text-left hover:bg-white/10 flex items-center space-x-2"
          data-testid="menu-edit"
        >
          <Edit2 className="w-3.5 h-3.5" />
          <span>Edit State</span>
        </button>

        {/* Add Transition */}
        <button
          onClick={() => {
            onAddTransition?.();
            onClose();
          }}
          className="w-full px-3 py-2 text-sm text-left hover:bg-white/10 flex items-center space-x-2"
          data-testid="menu-add-transition"
        >
          <ArrowRight className="w-3.5 h-3.5 text-blue-400" />
          <span>Add Transition</span>
        </button>

        {/* Add Effect */}
        <button
          onClick={() => {
            onAddEffect?.();
            onClose();
          }}
          className="w-full px-3 py-2 text-sm text-left hover:bg-white/10 flex items-center space-x-2"
          data-testid="menu-add-effect"
        >
          <Zap className="w-3.5 h-3.5 text-purple-400" />
          <span>Add Effect</span>
        </button>

        <div className="border-t border-white/10 my-1" />

        {/* Mark as Initial */}
        {!isInitial && (
          <button
            onClick={() => {
              onMarkInitial();
              onClose();
            }}
            className="w-full px-3 py-2 text-sm text-left hover:bg-white/10 flex items-center space-x-2"
            data-testid="menu-mark-initial"
          >
            <CheckCircle className="w-3.5 h-3.5 text-green-400" />
            <span>Mark as Initial</span>
          </button>
        )}

        {/* Mark as Final */}
        {!isFinal && (
          <button
            onClick={() => {
              onMarkFinal?.();
              onClose();
            }}
            className="w-full px-3 py-2 text-sm text-left hover:bg-white/10 flex items-center space-x-2"
            data-testid="menu-mark-final"
          >
            <Square className="w-3.5 h-3.5 text-red-400" />
            <span>Mark as Final</span>
          </button>
        )}

        {/* Make Compound */}
        {!isCompound && (
          <button
            onClick={() => {
              onMakeCompound?.();
              onClose();
            }}
            className="w-full px-3 py-2 text-sm text-left hover:bg-white/10 flex items-center space-x-2"
            data-testid="menu-make-compound"
          >
            <Layers className="w-3.5 h-3.5 text-yellow-400" />
            <span>Make Compound</span>
          </button>
        )}

        <div className="border-t border-white/10 my-1" />

        {/* Delete State */}
        <button
          onClick={() => {
            onDelete();
            onClose();
          }}
          className="w-full px-3 py-2 text-sm text-left hover:bg-red-500/20 text-red-400 flex items-center space-x-2"
          data-testid="menu-delete"
        >
          <Trash2 className="w-3.5 h-3.5" />
          <span>Delete State</span>
        </button>
      </div>
    </>
  );
};

export default NodeContextMenu;
